import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import { get } from "lodash";

import FitnessJournalEntries from "./fitnessJournalEntries";
import FitnessJournalCards from "./FitnessJournalCards";
import { getFitnessJournalSummary, getFitnessJournal, getFitnessGoals } from "../../../store/actions";
import SetGoals from "./setGoals";
import FilterPanel from "../../../sharedComponents/filterPanel";

import enGB from "date-fns/locale/en-GB";
registerLocale("enGB", enGB);

const FitnessJournal = ({
	getFitnessJournalSummary,
	getFitnessJournal,
	journalSummary,
	history,
	getFitnessGoals,
	fitnessGoals
}) => {
	const [startDate, setStartDate] = useState(new Date());
	const [showGoalsPanel, setShowGoalsPanel] = useState(false);
	const [showAddJournalPanel, setShowAddJournalPanel] = useState(false);

	const queryParam = `date=${moment(startDate).format("YYYY-MM-DD")}`;

	useEffect(() => {
		getFitnessJournalSummary(queryParam);
		getFitnessGoals(`start_date=${moment(startDate).format("YYYY-MM-DD")}`);
	}, [getFitnessJournalSummary, getFitnessGoals, queryParam, startDate]);

	const handleChange = (date) => {
		setStartDate(date);
		getFitnessJournalSummary(`date=${moment(date).format("YYYY-MM-DD")}`);
		getFitnessGoals(`start_date=${moment(date).format("YYYY-MM-DD")}`);
	};

	const onUpdateGoal = () => {
		getFitnessGoals();
		setShowGoalsPanel(false);
	};

	const renderGoalsPanel = () => {
		return (
			<FilterPanel show={showGoalsPanel} toggle={() => setShowGoalsPanel(!showGoalsPanel)} title="Set Goals" closeBtn>
				<SetGoals
					initialValues={
						fitnessGoals && fitnessGoals.id
							? fitnessGoals
							: {
								cardio: 0,
								resistance: 0,
								flexibility: 0,
								calories_burned: 0
							}
					}
					onUpdate={onUpdateGoal}
					toggle={() => setShowGoalsPanel(false)}
				/>
			</FilterPanel>
		);
	};

	return (
		<section className="page page-fitness-journal">
			<div className="container">
				<div className="d-flex flex-row justify-content-between">
					<h3>Weekly Journal</h3>
					<div>
						<DatePicker
							calendarClassName="show-week"
							selected={startDate}
							onChange={handleChange}
							dateFormat="yyyy-MM-dd"
							maxDate={new Date()}
							locale="enGB"
						/>
						{moment(startDate).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD") ? (
							<button
								className="btn btn-primary-dark btn-ghost ml-3 align-top"
								onClick={() => setShowGoalsPanel(true)}>
								Adjust Goal
						</button>
						) : (
								""
							)}
					</div>
				</div>

				<FitnessJournalCards data={journalSummary.summary} goal={fitnessGoals} />

				<FitnessJournalEntries
					history={history}
					journal={journalSummary.list}
					showAddJournalPanel={showAddJournalPanel}
					setShowAddJournalPanel={setShowAddJournalPanel}
					getFitnessJournal={getFitnessJournal}
					journalDate={startDate}
					range={{ start_date: journalSummary.start_date, end_date: journalSummary.end_date }}
				/>
				{renderGoalsPanel()}
			</div>
		</section>
	);
};

const mapStateToProps = (state) => ({
	journalSummary: get(state.FitnessJournal, "fitnessJournalSummary", {}),
	journal: get(state.FitnessJournal, "fitnessJournal", {}),
	fitnessGoals: get(state.FitnessJournal, "fitnessGoals", {})
});

const mapDispatchToProps = { getFitnessJournalSummary, getFitnessJournal, getFitnessGoals };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FitnessJournal);
